import request from '@/utils/request'
import qs from 'qs'

export function getChallengeList(data) {
    data = qs.stringify(data)
    return request({
        url: '/userChallenge/getChallengeList',
        method: 'post',
        data
    })
}

export function getChallengeDesc(data) {
    data = qs.stringify(data)
    return request({
        url: '/userChallenge/getChallengeDesc',
        method: 'post',
        data
    })
}

export function addChallenge(data) {
    data = qs.stringify(data)
    return request({
        url: '/userChallenge/addChallenge',
        method: 'post',
        data
    })
}

export function setViewed(data) {
    data = qs.stringify(data)
    return request({
        url: '/userChallenge/setViewed',
        method: 'post',
        data
    })
}

export function getSportDataDetail(data) {
    data = qs.stringify(data)
    return request({
        url: '/sport/getSportDataDetail',
        method: 'post',
        data
    })
}

export function getOutDoorClimbDes(data) {
    data = qs.stringify(data)
    return request({
        url: '/sport/getOutDoorClimbDes',
        method: 'post',
        data
    })
}

export function publish(data) {
    data = qs.stringify(data)
    return request({
        url: '/locus/publish',
        method: 'post',
        data
    })
}

export function getSportStatistics(data) {
    data = qs.stringify(data)
    return request({
        url: '/sport/getSportStatistics',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/api/sport.js